import React, { useState } from "react"
import Page from "../../common/page/Page"
import Form from "../../common/form/Form"
import axios from "axios"
import { Link, useNavigate, useSearchParams } from "react-router-dom"
import styles from "../../common/form/form.module.css"

const ResetPassword = () => {
  const [searchParams] = useSearchParams()
  const token = searchParams.get("token")

  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")
    setSuccess("")

    if (!password || !confirmPassword) {
      setError("Both fields are required.")
      return
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.")
      return
    }
    console.log(token)
    try {
      const response = await axios.post("/api/auth/reset-password", {
        new_password: password,
        token,
      })
      setSuccess(response.data.message)
      setPassword("")
      setConfirmPassword("")
      setTimeout(() => navigate("/login"), 2000)
    } catch (err) {
      console.error("Reset password error:", err)
      if (err.response) {
        setError(err.response.data.error || "Failed to reset password.")
      } else {
        setError("Network error, please try again.")
      }
    }
  }

  return (
    <Page title={"Reset Password"} searchDisabled={true}>
      <Form onSubmit={handleSubmit}>
        <div className={styles.cardContainer}>
          <div className={styles.cardHeader}>
            <h2>Reset Password</h2>
            <p>Set a new secure password for your account</p>
            <div className={styles.quote}>
              "Every day is a fresh opportunity to reset and restore."
            </div>
          </div>

          <div>
            <label htmlFor="new_password">New Password</label>
            <input
              type="password"
              id="new_password"
              name="new_password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div>
            <label htmlFor="confirm_password">Confirm Password</label>
            <input
              type="password"
              id="confirm_password"
              name="confirm_password"
              placeholder="••••••••"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          {error && <div className={styles.errorBanner}>{error}</div>}
          {success && <div className={styles.successBanner}>{success}</div>}

          <div>
            <button type="submit">Update Password</button>
          </div>

          <div className={styles.linkBox}>
            <p>
              <Link to={"/login"}>Back to Login</Link>
            </p>
          </div>
        </div>
      </Form>
    </Page>
  )
}

export default ResetPassword
